import { SxProps, Theme } from '@mui/material/styles';

export const sidebarPaperSX = ({
	isMobile = false,
	scrollable = false,
}: {
	isMobile: boolean;
	scrollable: boolean;
}): SxProps => ({
	...(isMobile && { borderRadius: 0 }),
	...(scrollable && { overflowY: 'auto' }),
});

export const sidebarContentSX = {
	paper: ({
		isMobile = false,
		scrollable = false,
		sidebarPaperSx = {},
	}: {
		sidebarPaperSx?: SxProps;
		isMobile: boolean;
		scrollable: boolean;
	}): SxProps<Theme> => ({
		h: '50px',
		...sidebarPaperSx,
		...(isMobile && { borderRadius: 0 }),
		...(scrollable && { overflowY: 'auto' }),
	}),
	stack: {
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	title: { mx: 'auto !important' },
	divider: { my: '10px' },
};
